// extracted by mini-css-extract-plugin
module.exports = {"talviewInitAllocatedTimePassedContent":"talviewInitAllocatedTimePassedModal__talviewInitAllocatedTimePassedContent___i6Kgv"};